import React, { Component, Fragment } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import axios from 'axios'
import AppURL from '../../api/AppURL'
import parse from 'html-react-parser';

class FooterMobile extends Component {

  constructor() {
    super();

    this.state = {
      address: "",
      android_app_link: "",
      ios_app_link: "",

      // STATIC CLICKABLE LINKS

      facbook_link: "https://www.facebook.com/ChrisAlphaTechCompany/",
      instagram_link: "https://www.instagram.com/chrisalphatechcompany/",
      youtube_link: "https://www.youtube.com/@ChrisAlphaTechCompany",
      linkedin_link: "https://www.linkedin.com/in/chrisalpha-tech-company-limited-4179b12b1",
      tiktok_link: "https://www.tiktok.com/@chris.alpha.tech",
     whatsapp_link: "https://wa.me/256784226089",

      copyright_text: "",
      loaderDiv: "",
      mainDiv: "d-none"
    }
  }

  componentDidMount() {

    axios.get(AppURL.AllSiteInfo)

      .then(response => {

        if (response.status === 200) {

          let JsonData = response.data[0];

          this.setState({

            address: JsonData.address,
            android_app_link: JsonData.android_app_link,
            ios_app_link: JsonData.ios_app_link,
            copyright_text: JsonData.copyright_text,
            loaderDiv: "d-none",
            mainDiv: ""

          });

        }

      })

      .catch(error => {

        console.log(error);

      });

  }

  render() {

    return (

      <Fragment>

        <div className="footerback m-0 mt-5 pt-3 shadow-sm">

          <Container className="text-center">

            <Row className="px-0 my-5">

              {/* OFFICE */}

              <Col lg={3} md={3} sm={6} xs={12} className="p-2">

                <h5 className="footer-menu-title">
                ADDRESS
                </h5>

                <div className={this.state.mainDiv}>
                  {parse(this.state.address)}
                </div>

              </Col>

              {/* MORE LINKS */}

              <Col lg={3} md={3} sm={6} xs={12} className="p-2">

                <h5 className="footer-menu-title">
                  MORE LINKS
                </h5>

                <Link to="/about" className="footer-link">
                  About Us
                </Link>

                <br />

                <Link to="/contact" className="footer-link">
                  Contact Us
                </Link>

                <br />

                <Link to="/newlettersubscribe" className="footer-link">
                  Subscribe
                </Link>

                <br />

                <Link to="/requestquote" className="footer-link">
                  Request For Quote
                </Link>

              </Col>

              {/* MORE INFO */}

              <Col lg={3} md={3} sm={6} xs={12} className="p-2">

                <h5 className="footer-menu-title">
                  MORE INFO
                </h5>

                <Link to="/products" className="footer-link">
                  Our Products
                </Link>

                <br />

                <Link to="/services" className="footer-link">
                  Our Services
                </Link>

                <br />

                <Link to="/livedemo" className="footer-link">
                  Live Demo
                </Link>

                <br />

                <Link to="/ourclients" className="footer-link">
                  Our Clients
                </Link>

              </Col>

              {/* SOCIAL MEDIA */}

              <Col lg={3} md={3} sm={6} xs={12} className="p-2">

                <h5 className="footer-menu-title">
                  OUR SOCIAL MEDIA
                </h5>

                <div className="social-icons">

                  <a
                    href="https://www.facebook.com/ChrisAlphaTechCompany/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab m-1 h4 fa-facebook"></i>
                  </a>

                  <a
                    href="https://www.youtube.com/@ChrisAlphaTechCompany"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab m-1 h4 fa-youtube"></i>
                  </a>

                  <a
                    href="https://www.instagram.com/chrisalphatechcompany/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab m-1 h4 fa-instagram"></i>
                  </a>

                  <a
                    href="https://www.linkedin.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab m-1 h4 fa-linkedin"></i>
                  </a>

                  <a
                    href="https://www.tiktok.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab m-1 h4 fa-tiktok"></i>
                  </a>


                  <a  href={this.state.whatsapp_link}  target="_blank"   rel="noopener noreferrer"> <i className="fab m-1 h4 fa-whatsapp"></i></a>

                </div>

              </Col>

            </Row>

          </Container>

          <Container fluid={true} className="text-center m-0 pt-3 pb-1 bg-dark">

            <h6 className="text-white">
              © Copyright 2026 by Chrisalpha Tech Company, All Rights Reserved
            </h6>

          </Container>

        </div>

      </Fragment>

    )

  }

}

export default FooterMobile;